import { QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

/** Clear the auth store when the session dies under us.
 *
 * Lazily imported to avoid an import cycle (auth -> api -> query -> auth).
 * Without this, a cookie that expires while the app is open leaves every query
 * failing forever: AuthGuard gates on `initialized`, which stays true, so the
 * user sees frozen panels with no error and no way back to the login screen.
 */
function onUnauthorized() {
  void import('./auth').then(({ useAuth }) => {
    if (useAuth.getState().whoami !== null) {
      useAuth.setState({ whoami: null })
    }
  })
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) onUnauthorized()
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, error) => {
        // Re-issuing a request that failed authentication just adds noise.
        if (error instanceof ApiError && error.status === 401) return false
        return count < 1
      },
    },
    mutations: { retry: 0 },
  },
})
